<template>
    <main id="form" class="relative z-40 update">
      <NoticeView v-if="open" @close="open = false" />
  
      <div class="mt-28 md:mt-16 w-full px-[12vw] sm:px-4">
        <h1 class="text-xl sm:text-2xl uppercase adlam text-center my-6">
          veuillez remplir les informations ci-dessous :
        </h1>
      </div>
      <Form
        class="px-[10vw] sm:px-4"
        v-if="_id && uid"
        id="monform"
        form_id="67ebde85c74c3e0134512cb5"
        :uid="uid"
        :submission_id="_id"
        server="https://api-gabarit.promo.dev"
        v-on:results="getResult"
        v-on:form_submit_loading="onLoading"
        :hideError="hiderror"
        @on_error="showErrorForm"
      />
      <p class="mentions mt-4 text-center">* Champs obligatoires</p>
    </main>
  </template>
  <script setup lang="ts">
  import router from "@/router";
  import axios from "axios";
  import { ref, onMounted } from "vue";
  import NoticeView from "@/components/NoticeView.vue";
  
  const hiderror = ref(true);
  const loading = ref(false);
  const error = ref(false);
  const _id = ref();
  const uid = ref();
  const open = ref(false);
  
  const onLoading = () => {
    loading.value = true;
  };
  
  const showErrorForm = () => {
    loading.value = false;
    error.value = true;
  };
  
  const getResult = (result) => {
    if (result && result.status) {
      sessionStorage.clear();
      sessionStorage.setItem("status", "WIN2");
   //   router.push({ name: "done" });
   window.location.reload();
    } else {
      alert("Une erreur est survenue, veuillez réessayer plus tard.");
    }
  };
  
  onMounted(async () => {
    try {
      setTimeout(() => {
        if (document.querySelector("#noticelink")) {
          document
            .querySelector("#noticelink")
            .addEventListener("click", (event) => {
              event.preventDefault();
              open.value = true;
            });
        }
      }, 1000);
  
      const currentRoute = router.currentRoute;
  
      if (currentRoute.params._id && currentRoute.params.uid) {
        _id.value = currentRoute.params._id;
        uid.value = currentRoute.params.uid;
      } else {
        const s_id = sessionStorage.getItem("_id");
        const s_uid = sessionStorage.getItem("uid");
  
        if (!s_id || !s_uid) {
          router.push("/");
        }
        _id.value = s_id;
        uid.value = s_uid;
      }
  
      if (!_id.value || !uid.value) {
        // router.push("/");
      }
  
      const { data: submission } = await axios.get(
        `https://api-gabarit.promo.dev/api/v2/submissions/${_id.value}?uid=${uid.value}`
      );
  
      if (!submission) {
        router.push("/");
      }
    } catch (e) {
      console.error(e);
    }
  });
  </script>
  